var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { EventEmitter } from "inf-ee";

var WebRTCSocket = function () {
  function WebRTCSocket(relayClient, configuration, params, debug) {
    this.relayClient = relayClient;
    this.configuration = configuration;
    this.debug = debug;
    this._ee = new EventEmitter();
    this._pendingCandidates = [];
    this._offerAccepted = false;
    this.send = this.send.bind(this);
    this.processIceCandidates = this.processIceCandidates.bind(this);
    this.initClient = this.initClient.bind(this);
    this.initHost = this.initHost.bind(this);
    this.handleIceCandidate = this.handleIceCandidate.bind(this);
    this.handleConnectionStateChange = this.handleConnectionStateChange.bind(this);
    this.configureDataChannel = this.configureDataChannel.bind(this);
    this.createConnection = this.createConnection.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.close = this.close.bind(this);
    this.connection = this.createConnection();

    switch (params.type) {
      case "client":
        // will connect to host
        this.initClient(params.hostId);
        this._remoteId = params.hostId;
        break;

      case "host":
        // will connect to client
        this.token = params.token;
        this.sendUrl = params.sendUrl;
        this._remoteId = params.clientId;
        break;

      default:
        throw Error("Unsupported Socket Parameters Type");
    }
  }

  Object.defineProperty(WebRTCSocket.prototype, "remoteId", {
    get: function get() {
      return this._remoteId;
    },
    enumerable: false,
    configurable: true
  });

  WebRTCSocket.prototype.on = function (eventName, handler) {
    this._ee.on(eventName, handler);
  };

  WebRTCSocket.prototype.once = function (eventName, handler) {
    this._ee.once(eventName, handler);
  };

  WebRTCSocket.prototype.off = function (eventName, handler) {
    this._ee.off(eventName, handler);
  };

  WebRTCSocket.prototype.send = function (message) {
    if (this.debug) {
      this._ee.emit("diagnostic", "Sent message on data channel: " + message);
    }

    this.dataChannel.send(message);
    return Promise.resolve();
  };

  WebRTCSocket.prototype.close = function () {
    this.connection.close();
  };

  WebRTCSocket.prototype.handleMessage = function (message) {
    if (message.body.type === "offer") {
      if (this.debug) {
        this._ee.emit("diagnostic", "Received offer: " + JSON.stringify(message.body));
      }

      this.initHost(message.body);
    } else if (message.body.type === "answer") {
      if (this.debug) {
        this._ee.emit("diagnostic", "Received answer: " + JSON.stringify(message.body));
      }

      this.connection.setRemoteDescription(message.body);
      this._offerAccepted = true;
      this.processIceCandidates();
    } else {
      if (this.debug) {
        this._ee.emit("diagnostic", "Received ICE Candidates: " + JSON.stringify(message.body));
      }

      this._pendingCandidates.push(message.body);

      this.processIceCandidates();
    }
  };

  WebRTCSocket.prototype.createConnection = function () {
    var connection = new RTCPeerConnection(this.configuration);
    connection.onconnectionstatechange = this.handleConnectionStateChange;
    connection.onicecandidate = this.handleIceCandidate;
    return connection;
  };

  WebRTCSocket.prototype.configureDataChannel = function () {
    var _this = this;

    this.dataChannel.onopen = function () {
      if (_this.debug) {
        _this._ee.emit("diagnostic", "Data channel opened.");
      }

      if (_this.relayMessageStream) {
        if (_this.debug) {
          _this._ee.emit("diagnostic", "Closing RELAY message stream.");
        }

        _this.relayMessageStream.close();
      }

      _this._ee.emit("open");
    };

    this.dataChannel.onclose = function () {
      if (_this.debug) {
        _this._ee.emit("diagnostic", "Data channel closed.");
      }

      _this._ee.emit("close");
    };

    this.dataChannel.onmessage = function (event) {
      if (_this.debug) {
        _this._ee.emit("diagnostic", "Message received on data channel: " + event.data);
      }

      _this._ee.emit("message", event.data);
    };
  };

  WebRTCSocket.prototype.handleConnectionStateChange = function (ev) {
    switch (this.connection.connectionState) {
      case "connected":
        // The connection has become fully connected
        if (this.debug) {
          this._ee.emit("diagnostic", "WebRTC connection established.");
        }

        break;

      case "disconnected":
        if (this.debug) {
          this._ee.emit("diagnostic", "WebRTC connection disconnected.");
        }

        break;

      case "failed":
        if (this.debug) {
          this._ee.emit("diagnostic", "WebRTC connection failed.");
        } // One or more transports has terminated unexpectedly or in an error


        break;

      case "closed":
        if (this.debug) {
          this._ee.emit("diagnostic", "WebRTC connection closed.");
        } // The connection has been closed


        break;
    }
  };

  WebRTCSocket.prototype.handleIceCandidate = function (ev) {
    var _this = this;

    if (ev.candidate) {
      if (this.debug) {
        this._ee.emit("diagnostic", "Sending ICE candidate: " + JSON.stringify(ev.candidate));
      }

      this.relayClient.sendMessage(this.token, ev.candidate, this.sendUrl).catch(function (error) {
        if (_this.debug) {
          _this._ee.emit("diagnostic", "Failed sending ICE candidate: " + JSON.stringify(error));
        }

        _this._ee.emit("error", error);
      });
    } else {
      if (this.debug) {
        this._ee.emit("diagnostic", "ICE gathering completed.");
      }
    }
  };

  WebRTCSocket.prototype.initHost = function (description) {
    return __awaiter(this, void 0, void 0, function () {
      var answer;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.connection.ondatachannel = function (event) {
              if (_this.debug) {
                _this._ee.emit("diagnostic", "Received new data channel: " + JSON.stringify(event.channel));
              }

              _this.dataChannel = event.channel;

              _this.configureDataChannel();
            };

            return [4
            /*yield*/
            , this.connection.setRemoteDescription(description)];

          case 1:
            _a.sent();

            if (this.debug) {
              this._ee.emit("diagnostic", "Set remote description on host: " + JSON.stringify(description));
            }

            return [4
            /*yield*/
            , this.connection.createAnswer()];

          case 2:
            answer = _a.sent();
            this.relayClient.sendMessage(this.token, answer, this.sendUrl).then(function () {
              if (_this.debug) {
                _this._ee.emit("diagnostic", "Host sent offer answer: " + JSON.stringify(answer));
              }
            }).catch(function (error) {
              if (_this.debug) {
                _this._ee.emit("diagnostic", "Host failed responding to offer:" + JSON.stringify(error));
              }

              _this._ee.emit("error", error);
            });
            return [4
            /*yield*/
            , this.connection.setLocalDescription(answer)];

          case 3:
            _a.sent();

            if (this.debug) {
              this._ee.emit("diagnostic", "Local description set to offer answer on host.");
            }

            this._offerAccepted = true;
            this.processIceCandidates();
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  WebRTCSocket.prototype.initClient = function (hostId) {
    return __awaiter(this, void 0, void 0, function () {
      var config, _a, offer_1, error_1;

      var _this = this;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 5,, 6]);

            this.dataChannel = this.connection.createDataChannel("uhst");

            if (this.debug) {
              this._ee.emit("diagnostic", "Data channel created on client.");
            }

            this.configureDataChannel();
            return [4
            /*yield*/
            , this.relayClient.initClient(hostId)];

          case 1:
            config = _b.sent();

            if (this.debug) {
              this._ee.emit("diagnostic", "Client configuration received from server.");
            }

            this.token = config.clientToken;
            this.sendUrl = config.sendUrl;
            _a = this;
            return [4
            /*yield*/
            , this.relayClient.subscribeToMessages(config.clientToken, this.handleMessage, undefined, undefined, config.receiveUrl)];

          case 2:
            _a.relayMessageStream = _b.sent();

            if (this.debug) {
              this._ee.emit("diagnostic", "Client subscribed to messages from server.");
            }

            return [4
            /*yield*/
            , this.connection.createOffer()];

          case 3:
            offer_1 = _b.sent();
            this.relayClient.sendMessage(this.token, offer_1, this.sendUrl).then(function () {
              if (_this.debug) {
                _this._ee.emit("diagnostic", "Client offer sent to host: " + JSON.stringify(offer_1));
              }
            }).catch(function (error) {
              if (_this.debug) {
                _this._ee.emit("diagnostic", "Client failed: " + JSON.stringify(error));
              }

              _this._ee.emit("error", error);
            });
            return [4
            /*yield*/
            , this.connection.setLocalDescription(offer_1)];

          case 4:
            _b.sent();

            if (this.debug) {
              this._ee.emit("diagnostic", "Local description set on client.");
            }

            return [3
            /*break*/
            , 6];

          case 5:
            error_1 = _b.sent();

            if (this.debug) {
              this._ee.emit("diagnostic", "Client failed: " + JSON.stringify(error_1));
            }

            this._ee.emit("error", error_1);

            return [3
            /*break*/
            , 6];

          case 6:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  WebRTCSocket.prototype.processIceCandidates = function () {
    if (this._offerAccepted) {
      if (this.debug) {
        this._ee.emit("diagnostic", "Offer accepted, processing cached ICE candidates.");
      }

      while (this._pendingCandidates.length > 0) {
        var candidate = this._pendingCandidates.pop();

        if (candidate) {
          this.connection.addIceCandidate(candidate);

          if (this.debug) {
            this._ee.emit("diagnostic", "Added ICE candidate: " + JSON.stringify(candidate));
          }
        }
      }
    }
  };

  return WebRTCSocket;
}();

export { WebRTCSocket };